import { render, staticRenderFns } from "./confirmVideoflow.vue?vue&type=template&id=1f38c337&lang=pug&"
import script from "./confirmVideoflow.vue?vue&type=script&lang=js&"
export * from "./confirmVideoflow.vue?vue&type=script&lang=js&"
import style0 from "./confirmVideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports